/* eslint @typescript-eslint/no-explicit-any: 0 */
import {Dispatch, useState} from 'react';
import {Grid, TextField, MenuItem} from '@material-ui/core';
import {PersonOutlineOutlined} from '@material-ui/icons';
import AllStatus from '../Underwritings/AllStatus';
import {BankingRequirementTypeOptions} from './SelectOptions';
import {RequirementPaymentType} from '../types';

interface CaseManagerMenuProps {
    children: any;
    index: number;
    value: any;
    showBankDisplay: Dispatch<any>;
}

function CaseManagerMenu(props: CaseManagerMenuProps) {
    const {children, index, value, showBankDisplay} = props;
    // state to update value of array element when necessary
    const [caseManagerInfo, setCaseManagerInfo] = useState(value);

    const handleCaseManagerMenuChange = (event: any, field: 'type' | 'status' | 'internal_note') => {
        value[field] = event.target.value;
        if (field === 'type') {
            value.title = BankingRequirementTypeOptions.filter((obj) => obj.value === event.target.value)[0].label;
        }
        setCaseManagerInfo({...value});
        showBankDisplay(value.type === RequirementPaymentType.PAYMENT_INFORMATION);
    };

    return (
        <>
            <Grid container spacing={1} direction="row" alignItems="center">
                <Grid item>
                    <PersonOutlineOutlined fontSize="small" />
                </Grid>
                <Grid item>
                    <h4>Case Manager Settings</h4>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={8} direction="row" alignItems="center">
                        <Grid item xs={3}>
                            <TextField
                                id={`requirement_type_${index}`}
                                select
                                fullWidth
                                label="Requirement"
                                placeholder="--"
                                variant="standard"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={caseManagerInfo.type}
                                onChange={(e) => {
                                    handleCaseManagerMenuChange(e, 'type');
                                }}
                                disabled={!!value.paymentInformationId || !!value.requirementId}
                            >
                                {BankingRequirementTypeOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                id={`status_${index}`}
                                select
                                fullWidth
                                label="Status"
                                placeholder="--"
                                variant="standard"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={caseManagerInfo.status}
                                onChange={(e) => {
                                    handleCaseManagerMenuChange(e, 'status');
                                }}
                            >
                                {AllStatus.map((option) => (
                                    <MenuItem key={option.name} value={option.name}>
                                        {option.description}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={5}>
                            <TextField
                                id={`notes_${index}`}
                                fullWidth
                                label="Notes"
                                placeholder="--"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={caseManagerInfo.internal_note}
                                onChange={(e) => {
                                    handleCaseManagerMenuChange(e, 'internal_note');
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {children}
        </>
    );
}

export default CaseManagerMenu;
